var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRoundApple(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.55 20.6784C16.57 21.6284 15.5 21.4784 14.47 21.0284C13.38 20.5684 12.38 20.5484 11.23 21.0284C9.79 21.6484 9.03 21.4684 8.17 20.6784C3.29 15.6484 4.01 7.98844 9.55 7.70844C10.9 7.77844 11.84 8.44844 12.63 8.50844C13.81 8.26844 14.94 7.57844 16.2 7.66844C17.71 7.78844 18.85 8.38844 19.6 9.46844C16.48 11.3384 17.22 15.4484 20.08 16.5984C19.51 18.0984 18.77 19.5884 17.54 20.6884L17.55 20.6784ZM12.53 7.64844C12.38 5.41844 14.19 3.57844 16.27 3.39844C16.56 5.97844 13.93 7.89844 12.53 7.64844Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundApple);
export default __webpack_public_path__ + "static/media/ic_round-apple.d01274f6b8bd4dff1af4e62fbe576331.svg";
export { ForwardRef as ReactComponent };